import { useRef, useState } from 'react';
import { hasEnabledByPlaygroundCookie, togglePlaygroundCookie } from './utils';

export const useDevPlayground = () => {
	const devCounterRef = useRef(1);
	const [isEnabled, setIsEnabled] = useState(hasEnabledByPlaygroundCookie());

	const tryToEnable = () => {
		if (devCounterRef.current % 5 === 0) {
			setIsEnabled((prevValue) => {
				const newState = !prevValue;

				togglePlaygroundCookie(newState);

				return newState;
			});
		}

		devCounterRef.current++;
	};

	return {
		isEnabled,
		tryToEnable,
	};
};
